import { AppDispatch, RootState, store } from "../../../../redux/store";
import { PatientListResponse } from "../../../../interfaces/api/patients";
import { services } from "../../../../api";
import { setPatients } from "./reducer";

/**
 * Fetch patients list with paging
 * @param {number} page - Page number (1-based)
 * @param {number} pageSize - Number of items per page
 * @returns {Promise<PatientListResponse | null>} API response or null on error
 */
export const fetchPatients = async (
  page: number,
  pageSize: number,
): Promise<PatientListResponse | null> => {
  try {
    const res = await services.patients.getPatients(page, pageSize);
    if (res.result === "success" && res.content.data) {
      store.dispatch(setPatients(res.content.data));
    }
    return res;
  } catch (error) {
    return null;
  }
};

export const deletePatient = (id: string) => async (dispatch: AppDispatch) => {
  try {
    await services.patients.deletePatient(id);
    fetchPatients(1, 100);
  } catch (error) {
    console.error("Error deleting patient:", error);
    throw error;
  }
};
